import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const userListTodo = createAsyncThunk('userList', async ({ pageable: data, navigate }) => {
    const type = "admin_user"
    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `user_list?type=${type}`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const userListSlice = createSlice({
    name: 'userList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(userListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(userListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default userListSlice.reducer;

